import { render } from "./Colaboradores.vue?vue&type=template&id=1e3af742&scoped=true"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"

import "./Colaboradores.vue?vue&type=style&index=0&id=1e3af742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3af742"]])

export default __exports__